import {
  gridGutter1q3,
  fontSize12,
  gridGutter
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";

import theme from '../../../../js/shared/new-theme';

export const messageBarStyle = (bottomSize = '114px') => `
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${theme.palette.gray[100].value};
  min-height: 35px;
  @media (max-width: 767px) {
    min-height: auto;
    margin: 0 -30px;
    padding: 3px;
    justify-content: flex-start;
    padding-left: ${gridGutter}px;
    position: fixed;
    right: 0;
    left: 24px;
    bottom: ${bottomSize};
  }
  
  p {
    font-weight: 500;
    padding: ${gridGutter1q3}px 0 ${gridGutter1q3}px 0;
    margin: 0 ${gridGutter1q3}px 0 0;
    text-align: center;
    @media (max-width: 767px) {
      text-align: left;
      font-size: ${fontSize12};
      padding: ${gridGutter1q3}px ${gridGutter1q3}px;
    }
    span {
      font-weight: bold;
    }
  }
`;
